//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/plugins/filters'

export default {
  name: 'OptionHistorySelectPage',

  layout: 'page',

  data() {
    return {
      date: new Date(),
      formLoading: false,
      floor: null,
      floors: null,
    }
  },

  computed: {
    month() {
      return formatDate(this.date, 'yyyy-MM')
    },
  },

  mounted() {
    this.fetchOptions()
  },

  methods: {
    async fetchOptions() {
      this.formLoading = true

      const res = await this.$axios.$get('/option/history/floors', {
        params: {
          month: this.month,
        },
      })

      this.formLoading = false

      const { floors } = res.data

      if (!floors?.length) {
        this.$router.push('/option/history')

        return
      }

      this.floors = floors
      this.floor = floors[0].id
    },
    save() {
      this.$router.push({
        path: '/option/history',
        query: {
          floor: this.floor,
        },
      })
    },
  },
}
